module.exports = __webpack_public_path__ + "img/睦邻中心1.760e9884.jpg";